module.exports = __webpack_public_path__ + "files/e88d3f4b12fca7991000b8448ce58048.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-2.png
// module id = 1455
// module chunks = 60